import { Route } from "react-router-dom";

import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import OfferingDetail from "@/pages/OfferingDetail";
import Coaches from "@/pages/Coaches";
import CoachProfile from "@/pages/CoachProfile";
import NotFound from "@/pages/NotFound";

// Children of the <PublicLayout /> layout route. React Router flattens this
// fragment inside <Routes>, so these behave exactly like inline <Route>s.
export const publicRoutes = (
  <>
    <Route path="/" element={<Home />} />
    <Route path="/marketplace" element={<Marketplace />} />
    <Route path="/marketplace/:id" element={<OfferingDetail />} />
    <Route path="/offerings/:id" element={<OfferingDetail />} />
    <Route path="/coaches" element={<Coaches />} />
    <Route path="/coaches/:id" element={<CoachProfile />} />
    <Route path="*" element={<NotFound />} />
  </>
);
